<template>
  <a-card>
    <div class="search">
      年份选择：
      <a-date-picker
        :value="year"
        mode="year"
        :open="isOpen"
        format="YYYY"
        placeholder="开始年"
        @openChange="handleOpenChange"
        @panelChange="handlePanelChange"
        @change="handleChange"
      />
      <a-button
        icon="download"
        type="primary"
        class="export-button"
        :loading="loading"
        @click="_getList"
      >
        查询
      </a-button>
    </div>

    <a-collapse accordion>
      <a-collapse-panel
        v-for="item in list"
        :key="item.index"
        :header="item.title"
      >
        <ListTable
          :list="item.children"
          :year="formatYear"
          @getList="_getList"
        />
      </a-collapse-panel>
    </a-collapse>
  </a-card>
</template>

<script>
import moment from 'moment'
import { getList } from './api'
import ListTable from './components/ListTable'

export default {
  data() {
    return {
      year: moment(new Date()),
      isOpen: false,
      loading: false,
      list: [],
    }
  },
  components: {
    ListTable,
  },
  mounted() {
    this._getList()
  },
  computed: {
    formatYear() {
      return moment(this.year).format('YYYY')
    },
  },
  methods: {
    handleChange() {
      this.year = null
    },
    handleOpenChange(status) {
      this.isOpen = status
    },
    handlePanelChange(value) {
      this.year = value
      this.isOpen = false
    },
    _getList() {
      const year = moment(this.year).format('YYYY')

      getList({ year }).then(({ data }) => {
        this.list = this.sortData(data)
      })
    },
    sortData(data) {
      const json = {}
      for (let i = 0; i < data.length; i++) {
        const type = data[i].type
        if (!json[type]) {
          json[type] = {
            title: this.filterType(type),
            children: [],
          }
        }
        json[type].children.push(data[i])
      }
      return json
    },
    filterType(type) {
      const dataType = {
        1: '财务基本数据',
        2: '盈利能力',
        3: '偿债能力',
        4: '增长率',
        5: '运营能力',
      }
      return dataType[type]
    },
  },
}
</script>

<style scoped lang="less">
.segmentation {
  margin: 0 20px;
}
.export-button {
  margin-left: 30px;
  position: relative;
  top: -1px;
}

.search {
  margin-bottom: 50px;
}
</style>
